import { Tooltip, Typography } from '@mui/material'
import { DateTime } from 'luxon'
import { RaRecord, useRecordContext } from 'react-admin'

import { TIME_REGEX, parseDateAsDateTime } from '../utils/dates'

interface DateTooltipFieldProps {
  source: string
  addTime?: boolean
  relative?: boolean
  className?: string
  record?: RaRecord
}

const DateTooltipField = ({ source, addTime = false, relative = false, className, record }: DateTooltipFieldProps) => {
  const contextRecord = useRecordContext({ record })
  const dateStr = contextRecord?.[source] as string | undefined
  const dt = parseDateAsDateTime(dateStr)
  return (
    <Typography component="span" variant="body2" className={className}>
      {dateStr ? (
        DateTime.isDateTime(dt) && dt.isValid ? (
          relative ? (
            <Tooltip title={dt.toLocaleString(DateTime.DATETIME_SHORT)}>
              <span>{dt.toRelative()}</span>
            </Tooltip>
          ) : addTime ? (
            <span>{dt.toLocaleString(DateTime.DATETIME_SHORT)}</span>
          ) : (
            <Tooltip title={dt.toLocaleString(DateTime.DATETIME_SHORT)}>
              <span>{dt.toLocaleString(DateTime.DATE_SHORT)}</span>
            </Tooltip>
          )
        ) : TIME_REGEX.test(dateStr) ? (
          // We remove seconds if "HH:mm:ss" format
          dateStr.replace(TIME_REGEX, '$1:$2')
        ) : (
          dateStr
        )
      ) : (
        'n/a'
      )}
    </Typography>
  )
}

export default DateTooltipField
